'use strict';
var parent = require('../../actual/instance/reduce');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/instance/reduce.js
// module id = 624
// module chunks = 13